module.exports = {
    AmenidadesData: () => {
        return [[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[316.875,334.112]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[466.812,387.309]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[477.635,409.077]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[619.234,430.323]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[739.855,640.387]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[843.28,659.447]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[369.196,318.625]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[497.884,373.894]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[503.222,395.326]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[633.264,420.16]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[702.302,630.429]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[797.719,653.61]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[421.471,304.905]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[530.326,361.682]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[530.564,382.667]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[649.088,410.613]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[668.378,619.06]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[754.698,645.833]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[473.607,292.807]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[559.397,371.077]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[563.904,350.626]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[638.364,606.527]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[666.516,401.701]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[714.763,636.328]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[525.559,282.21]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[589.504,360.532]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[598.433,340.689]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[612.445,593.066]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[678.362,625.315]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[685.376,393.446]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[577.32,273.028]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[590.74,578.891]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[620.711,351.019]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[633.769,331.843]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[645.861,613.009]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[705.521,385.867]]
            },],[{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[573.239,564.234]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[617.484,599.662]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[628.867,265.156]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[652.835,342.502]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[669.759,324.041]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[726.789,378.967]]
            },],[{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[559.92,549.281]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[593.409,585.487]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[680.226,258.554]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[685.749,334.98]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[706.305,317.277]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[749.056,372.768]]
            },],[{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[550.668,534.221]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[573.694,570.714]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[719.321,328.435]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[731.408,253.169]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[743.302,311.527]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[772.189,367.28]]
            },],[{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[545.283,519.234]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[558.279,555.579]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[753.419,322.83]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[780.643,306.75]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[782.42,248.927]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[796.051,362.492]]
            },],[{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[543.579,504.464]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[547.082,540.274]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[787.948,318.164]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[818.257,302.941]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[820.533,358.419]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[833.297,245.813]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[541.239,524.903]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[546.608,490.025]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[823.586,314.727]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[846.25,355.294]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[856.781,300.419]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[884.724,244.239]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[541.631,509.673]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[555.142,476.111]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[860.651,312.761]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[873.537,353.31]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[896.485,299.437]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[936.937,244.526]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[547.707,494.873]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[568.545,462.934]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[898.581,312.197]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[901.905,352.43]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[936.813,299.915]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[989.375,246.557]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[558.789,480.735]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[586.105,450.645]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[930.913,352.568]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[936.88,312.917]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[977.29,301.72]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1041.58,250.161]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[574.176,467.427]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[607.125,439.342]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[960.179,353.643]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[975.138,314.805]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1017.52,304.729]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1093.2,255.185]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[593.173,455.063]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[630.943,429.081]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[989.381,355.572]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1013.02,317.751]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1057.2,308.823]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1143.97,261.487]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[615.122,443.711]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[656.95,419.882]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1018.25,358.279]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1050.25,321.661]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1096.07,313.905]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1193.72,268.96]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[639.361,433.399]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[684.558,411.73]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1046.55,361.67]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1086.63,326.415]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1133.95,319.853]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1242.35,277.472]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[665.294,424.115]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[713.247,404.584]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1074.12,365.663]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1122,331.915]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1170.72,326.568]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1289.84,286.923]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[692.354,415.81]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[742.539,398.367]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1100.82,370.162]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1156.28,338.046]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1206.32,333.938]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1336.24,297.207]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[720.062,408.405]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[772.042,392.989]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1126.56,375.094]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1189.44,344.728]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1240.73,341.888]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1381.67,308.265]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[748.019,401.803]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[801.433,388.353]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1151.29,380.4]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1221.45,351.902]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1273.98,350.367]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1426.28,320.08]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[775.898,395.891]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[830.455,384.354]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1174.94,386.043]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1252.33,359.537]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1306.08,359.356]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1470.24,332.682]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[803.43,390.523]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[858.895,380.857]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1197.49,391.976]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1282.12,367.599]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1337.1,368.833]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1513.79,346.109]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[830.466,385.563]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[886.63,377.737]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1218.9,398.181]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1310.86,376.095]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1367.08,378.826]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1557.13,360.473]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[856.943,380.893]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[913.613,374.86]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1239.16,404.63]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1338.58,385.032]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1396.08,389.359]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1600.52,375.905]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[882.858,376.456]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[939.881,372.122]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1258.26,411.283]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1365.37,394.418]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1424.2,400.47]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1644.25,392.578]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[908.226,372.28]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[965.53,369.523]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1276.19,418.108]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1391.27,404.289]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1451.46,412.228]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1688.59,410.738]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[933.465,368.466]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[991.032,367.187]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1293.18,425.104]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1416.43,414.727]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1477.97,424.748]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1733.66,430.73]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[959.013,365.116]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1016.82,365.267]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1309.4,432.298]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1440.84,425.807]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1503.62,438.134]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1779.21,452.915]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[984.876,362.257]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1042.9,363.832]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1324.81,439.752]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1464.32,437.564]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1528.09,452.433]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1824.77,477.624]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1011.06,359.886]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1069.24,362.905]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1339.32,447.6]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1486.67,450.064]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1551.09,467.691]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1869.76,505.185]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1037.56,358.01]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1095.84,362.505]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1352.72,455.999]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1507.66,463.447]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1572.27,484.005]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1913.37,535.914]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1064.39,356.653]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1122.65,362.663]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1364.68,465.049]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1526.88,477.892]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1591.15,501.53]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1091.52,355.86]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1149.64,363.43]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1374.82,474.775]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1543.75,493.534]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1607.06,520.407]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1118.9,355.666]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1176.71,364.84]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1382.74,485.147]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1557.61,510.423]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1619.21,540.705]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1146.45,356.12]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1203.76,366.945]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1388.07,496.095]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1567.74,528.523]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1626.69,562.378]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1174.08,357.255]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1230.66,369.776]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1390.46,507.528]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1573.44,547.735]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1628.63,585.297]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1201.66,359.117]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1257.24,373.377]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1389.56,519.331]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1573.95,567.898]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1624.11,609.234]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1229.03,361.761]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1283.31,377.799]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1385.04,531.36]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1568.54,588.776]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1612.22,633.857]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1255.96,365.249]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1308.59,383.093]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1376.61,543.432]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1556.49,610.044]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1592.14,658.709]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1282.23,369.618]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1332.81,389.286]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1364.05,555.352]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1537.23,631.325]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1563.25,683.268]]
            },],[{
            name:"Portería",
            tipo:"Portería",
            verts:[[1307.52,374.922]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1347.2,566.866]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1355.62,396.413]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1510.28,652.114]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1525.11,706.848]]
            },{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[1892.2,1041.36]]
            },],[{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1326.04,577.713]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1331.51,381.186]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1376.64,404.477]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1475.43,671.861]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1477.64,728.715]]
            },],[{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1300.69,587.637]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1353.84,388.409]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1395.5,413.451]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1421.26,748.141]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1432.79,690.003]]
            },],[{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1271.42,596.353]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1356.74,764.325]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1374.11,396.583]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1382.76,705.901]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1411.77,423.298]]
            },],[{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1238.18,603.541]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1284.93,776.42]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1325.64,718.847]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1391.4,405.709]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1424.47,433.968]]
            },],[{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1201.38,609.032]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1207.5,783.993]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1262.49,728.428]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1405.12,415.677]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1433.06,445.325]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1126.78,786.975]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1161.95,612.785]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1195.08,734.496]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1415.38,426.327]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1437.68,457.204]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[1044.97,785.577]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1120.76,614.855]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1125.15,737.114]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1422.4,437.519]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1438.59,469.467]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[964.02,780.145]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[1054.28,736.447]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1078.59,615.333]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1426.43,449.148]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1436.06,482.011]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[885.504,771.129]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[983.802,732.744]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[1036.04,614.336]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1427.72,461.147]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1430.36,494.768]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[358.18,1074.66]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[810.62,759.027]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[914.827,726.296]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[993.614,611.986]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1421.74,507.698]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1426.53,473.479]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[249.892,1021.73]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[740.109,744.469]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[848.142,717.524]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[951.664,608.458]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1410.45,520.797]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1423.13,486.142]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[161.337,966.999]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[674.609,727.84]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[784.445,706.648]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[910.509,603.805]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1396.4,534.046]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1417.43,499.154]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[91.511,911.961]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[614.822,709.436]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[724.518,693.819]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[870.559,598.033]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1379.22,547.374]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1409.06,512.508]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[38.5573,857.849]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[561.152,689.687]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[668.972,679.339]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[832.202,591.226]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1358.72,560.695]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1397.77,526.169]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[0.489217,805.415]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[513.807,669.007]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[618.284,663.532]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[795.826,583.492]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1334.75,573.887]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1383.32,540.068]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[472.81,647.724]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[572.77,646.709]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[761.792,574.973]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1307.17,586.791]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1365.44,554.102]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[437.991,626.078]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[532.516,629.147]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[730.359,565.862]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1275.98,599.255]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1343.96,568.151]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[409.276,604.135]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[497.609,610.936]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[701.711,556.282]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1241.22,611.079]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1318.71,582.045]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[386.609,581.979]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[468.131,592.131]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[675.951,546.271]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1203.05,622.101]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1289.62,595.619]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[369.916,559.763]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[444.175,572.836]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[653.198,535.78]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1161.73,632.205]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1256.73,608.737]]
            },],[{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[359.187,537.664]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[425.903,553.2]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[633.718,524.745]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1117.55,641.223]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1220.09,621.231]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[19.626,506.978]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[354.31,515.899]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[413.371,533.446]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[617.801,513.206]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1070.83,648.918]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1179.82,632.902]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[49.815,474.963]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[355.082,494.685]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[406.519,513.818]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[605.678,501.288]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[1022.08,654.943]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1136.12,643.441]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[84.7594,445.508]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[361.369,474.2]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[405.318,494.532]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[597.574,489.148]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[972.043,658.846]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1089.41,652.341]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[124.022,418.555]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[372.951,454.616]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[409.629,475.796]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[593.612,476.961]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[921.734,660.332]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[1040.44,659.128]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[167.275,394.051]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[389.624,436.084]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[419.311,457.797]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[593.876,464.901]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[872.29,659.254]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[990.213,663.438]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[214.243,371.969]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[411.18,418.744]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[434.204,440.71]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[598.41,453.136]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[824.879,655.599]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[939.898,665.063]]
            },],[{
            name:"Piscina adultos",
            tipo:"Piscina adultos",
            verts:[[264.685,352.309]]
            },{
            name:"Baños piscina",
            tipo:"Banos Piscina",
            verts:[[437.411,402.74]]
            },{
            name:"Piscina infantil",
            tipo:"Piscina Infantil",
            verts:[[454.132,424.705]]
            },{
            name:"Juegos de niños",
            tipo:"Juegos de niños",
            verts:[[607.226,441.834]]
            },{
            name:"Cuartos técnicos",
            tipo:"Cuartos Tecnicos",
            verts:[[780.658,649.432]]
            },{
            name:"Portería",
            tipo:"Portería",
            verts:[[890.738,663.896]]
            },],]
    }
}